import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import HomePageV2 from '@/components/LandingPageV2'
import { LandingPageV2Layout } from '@/components/LandingPageV2'

const IndexPage = () => {
  const { t } = useTranslation()

  const [pageTitle, setPageTitle] = useState(
    ' - Interactive Digital Content for Health'
  )

  useEffect(() => {
    setPageTitle(` - ${t('subtitles.tabText')}`)
  }, [t])

  return (
    <LandingPageV2Layout title={pageTitle}>
      <HomePageV2 />
    </LandingPageV2Layout>
  )
}

export default IndexPage
